import { MB } from '@wetransfer/transfer/constant/sizes';

export const GENERIC_ERROR_MESSAGE_KEY = 'exception.generic_error';

export const INVALID_FILE_ERROR_MESSAGE_KEY = 'exception.invalid_file_error';

export const MAX_UPLOAD_FILE_SIZE_MB = 5;

export const MAX_UPLOAD_FILE_SIZE = MAX_UPLOAD_FILE_SIZE_MB * MB;

export const UPLOAD_FILE_NAME_REGEX = /.(jp(e?)g|png)$/i;

export const MIN_WALLPAPER_WIDTH = 1920;

export const MIN_WALLPAPER_HEIGHT = 1200;
